module.exports = __webpack_public_path__ + "static/media/start-screen-marketplace.fc0c3c58.png";